import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';

import { ApiClientConfig } from './api-client-config';
import { AnalisiBilancioApiClient } from './entities/analisi-bilancio.api-client';
import { AttivitaPartecipataApiClient } from './entities/attivita-partecipata.api-client';
import { BdapCepApiClient } from './entities/bdap-cep.api-client';
import { BilancioConsolidatoRigaDettaglioApiClient } from './entities/bilancio-consolidato-riga-dettaglio.api-client';
import { BilancioConsolidatoRigaApiClient } from './entities/bilancio-consolidato-riga.api-client';
import { BilancioConsolidatoApiClient } from './entities/bilancio-consolidato.api-client';
import { BilancioEnteRigaApiClient } from './entities/bilancio-ente-riga.api-client';
import { BilancioEnteApiClient } from './entities/bilancio-ente.api-client';
import { BilancioPartecipataRigaApiClient } from './entities/bilancio-partecipata-riga.api-client';
import { BilancioPartecipataApiClient } from './entities/bilancio-partecipata.api-client';
import { BilancioRigheApiClient } from './entities/bilancio-righe.api-client';
import { ChiusuraRipristinoEsercizioApiClient } from './entities/chiusura-ripristino-esercizio.api-client';
import { CofiApiClient } from './entities/cofi.api-client';
import { CompagineSocialeApiClient } from './entities/compagine-sociale.api-client';
import { ContoEconomicoAnnoPrecedenteApiClient } from './entities/conto-economico-anno-precedente.api-client';
import { ControlloCostiPerMissioneApiClient } from './entities/controllo-costi-per-missione.api-client';
import { ControlloSaldiApiClient } from './entities/controllo-saldi.api-client';
import { CostiPerMissioneApiClient } from './entities/costi-per-missione.api-client';
import { DocumentoPartecipataApiClient } from './entities/documento-partecipata.api-client';
import { EnteApiClient } from './entities/ente.api-client';
import { GapApiClient } from './entities/gap.api-client';
import { IncaricoPartecipataApiClient } from './entities/incarico-partecipata.api-client';
import { MatriceApiClient } from './entities/matrice.api-client';
import { MissioneApiClient } from './entities/missione.api-client';
import { ModelloContabileRigaApiClient } from './entities/modello-contabile-riga.api-client';
import { ModelloContabileApiClient } from './entities/modello-contabile.api-client';
import { ModuloEnteApiClient } from './entities/modulo-ente.api-client';
import { ModuloApiClient } from './entities/modulo.api-client';
import { MoltiplicatoreApiClient } from './entities/moltiplicatore.api-client';
import { NotaIntegrativaCepApiClient } from './entities/nota-integrativa-cep.api-client';
import { NotificaApiClient } from './entities/notifica.api-client';
import { ParametroGapApiClient } from './entities/parametro-gap.api-client';
import { ParametroPerimetroApiClient } from './entities/parametro-perimetro.api-client';
import { PartecipataEnteApiClient } from './entities/partecipata-ente.api-client';
import { PartecipataIndirettaApiClient } from './entities/partecipata-indiretta.api-client';
import { PartecipataServizioApiClient } from './entities/partecipata-servizio.api-client';
import { PartecipataApiClient } from './entities/partecipata.api-client';
import { PerimetroApiClient } from './entities/perimetro.api-client';
import { PianoContiApiClient } from './entities/piano-conti.api-client';
import { PianoFinanziarioApiClient } from './entities/piano-finanziario.api-client';
import { PrimaNotaRigaApiClient } from './entities/prima-nota-riga.api-client';
import { PrimaNotaApiClient } from './entities/prima-nota.api-client';
import { ProgrammaApiClient } from './entities/programma.api-client';
import { ProspettoApiClient } from './entities/prospetto.api-client';
import { RaccordoApiClient } from './entities/raccordo.api-client';
import { RiduzioneProporzionaleRigaApiClient } from './entities/riduzione-proporzionale-riga.api-client';
import { RiduzioneProporzionaleApiClient } from './entities/riduzione-proporzionale.api-client';
import { RiepilogoProspettiApiClient } from './entities/riepilogo-prospetti.api-client';
import { RuoloApiClient } from './entities/ruolo.api-client';
import { SaldoInizialeApiClient } from './entities/saldo-iniziale.api-client';
import { ScritturaElisioneRigaApiClient } from './entities/scrittura-elisione-riga.api-client';
import { ScritturaElisioneApiClient } from './entities/scrittura-elisione.api-client';
import { ScritturaPreconsolidamentoRigaApiClient } from './entities/scrittura-preconsolidamento-riga.api-client';
import { ScritturaPreconsolidamentoApiClient } from './entities/scrittura-preconsolidamento.api-client';
import { ServizioPubblicoApiClient } from './entities/servizio-pubblico.api-client';
import { SoggettoApiClient } from './entities/soggetto.api-client';
import { StampeCepApiClient } from './entities/stampe-cep.api-client';
import { StampePartecipoApiClient } from './entities/stampe-partecipo.api-client';
import { StrutturaProspettoApiClient } from './entities/struttura-prospetto.api-client';
import { TipologiaCompensoApiClient } from './entities/tipologia-compenso.api-client';
import { TipologiaDocumentoApiClient } from './entities/tipologia-documento.api-client';
import { TipologiaIncaricoApiClient } from './entities/tipologia-incarico.api-client';
import { TipologiaPartecipazioneApiClient } from './entities/tipologia-partecipazione.api-client';
import { TipologiaRegistrazioneApiClient } from './entities/tipologia-registrazione.api-client';
import { UtenteEnteApiClient } from './entities/utente-ente.api-client';
import { UtentePartecipataApiClient } from './entities/utente-partecipata.api-client';
import { UtenteApiClient } from './entities/utente.api-client';
import { FileApiClient } from './file.api-client';

import { CancellazioniCepApiClient } from './entities/cancellazioni-cep.api-client';
import { ValoriAnnoPrecedenteApiClient } from './entities/valori-anno-precedente.api-client';

import { CancellazioniPartecipoApiClient } from './entities/cancellazioni-partecipo.api-client';

import { ChiusuraRipristinoConsolidatoApiClient } from './entities/chiusura-ripristino-consolidato.api-client';

import { ContiNonRaccordatiApiClient } from './entities/conti-non-raccordati.api-client';

import { TemplateApiClient } from './entities/template.api-client';

import { ImportazioneScrittureApiClient } from './entities/importazione-scritture.api-client';

import { AccrualCepApiClient } from './entities/accrual-cep.api-client';

@NgModule({
  imports: [CommonModule],
})
export class ApiClientModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: ApiClientModule
  ) {
    if (parentModule) {
      throw new Error(
        'ApiClientModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(
    config: ApiClientConfig
  ): ModuleWithProviders<ApiClientModule> {
    return {
      ngModule: ApiClientModule,

      providers: [
        AccrualCepApiClient,
        {
          provide: 'accrualCepApiClient',
          useExisting: AccrualCepApiClient,
        },
        ImportazioneScrittureApiClient,
        {
          provide: 'importazioneScrittureApiClient',
          useExisting: ImportazioneScrittureApiClient,
        },
        TemplateApiClient,
        {
          provide: 'templateApiClient',
          useExisting: TemplateApiClient,
        },
        ContiNonRaccordatiApiClient,
        {
          provide: 'contiNonRaccordatiApiClient',
          useExisting: ContiNonRaccordatiApiClient,
        },
        ChiusuraRipristinoConsolidatoApiClient,
        {
          provide: 'chiusuraRipristinoConsolidatoApiClient',
          useExisting: ChiusuraRipristinoConsolidatoApiClient,
        },
        CancellazioniPartecipoApiClient,
        {
          provide: 'cancellazioniPartecipoApiClient',
          useExisting: CancellazioniPartecipoApiClient,
        },
        CancellazioniCepApiClient,
        {
          provide: 'cancellazioniCepApiClient',
          useExisting: CancellazioniCepApiClient,
        },
        BdapCepApiClient,
        {
          provide: 'bdapCepApiClient',
          useExisting: BdapCepApiClient,
        },
        NotaIntegrativaCepApiClient,
        {
          provide: 'notaIntegrativaCepApiClient',
          useExisting: NotaIntegrativaCepApiClient,
        },
        ChiusuraRipristinoEsercizioApiClient,
        {
          provide: 'chiusuraRipristinoEsercizioApiClient',
          useExisting: ChiusuraRipristinoEsercizioApiClient,
        },
        ContoEconomicoAnnoPrecedenteApiClient,
        {
          provide: 'contoEconomicoAnnoPrecedenteApiClient',
          useExisting: ContoEconomicoAnnoPrecedenteApiClient,
        },
        CostiPerMissioneApiClient,
        {
          provide: 'costiPerMissioneApiClient',
          useExisting: CostiPerMissioneApiClient,
        },
        RiepilogoProspettiApiClient,
        {
          provide: 'riepilogoProspettiApiClient',
          useExisting: RiepilogoProspettiApiClient,
        },
        StampeCepApiClient,
        {
          provide: 'stampeCepApiClient',
          useExisting: StampeCepApiClient,
        },
        CofiApiClient,
        {
          provide: 'cofiApiClient',
          useExisting: CofiApiClient,
        },
        PrimaNotaRigaApiClient,
        {
          provide: 'primaNotaRigaApiClient',
          useExisting: PrimaNotaRigaApiClient,
        },
        PrimaNotaApiClient,
        {
          provide: 'primaNotaApiClient',
          useExisting: PrimaNotaApiClient,
        },
        StampePartecipoApiClient,
        {
          provide: 'stampePartecipoApiClient',
          useExisting: StampePartecipoApiClient,
        },
        BilancioConsolidatoRigaApiClient,
        {
          provide: 'bilancioConsolidatoRigaApiClient',
          useExisting: BilancioConsolidatoRigaApiClient,
        },
        BilancioConsolidatoRigaDettaglioApiClient,
        {
          provide: 'bilancioConsolidatoRigaDettaglioApiClient',
          useExisting: BilancioConsolidatoRigaDettaglioApiClient,
        },
        BilancioConsolidatoApiClient,
        {
          provide: 'bilancioConsolidatoApiClient',
          useExisting: BilancioConsolidatoApiClient,
        },
        RiduzioneProporzionaleRigaApiClient,
        {
          provide: 'riduzioneProporzionaleRigaApiClient',
          useExisting: RiduzioneProporzionaleRigaApiClient,
        },
        RiduzioneProporzionaleApiClient,
        {
          provide: 'riduzioneProporzionaleApiClient',
          useExisting: RiduzioneProporzionaleApiClient,
        },
        BilancioPartecipataRigaApiClient,
        {
          provide: 'bilancioPartecipataRigaApiClient',
          useExisting: BilancioPartecipataRigaApiClient,
        },
        BilancioEnteRigaApiClient,
        {
          provide: 'bilancioEnteRigaApiClient',
          useExisting: BilancioEnteRigaApiClient,
        },
        SoggettoApiClient,
        {
          provide: 'soggettoApiClient',
          useExisting: SoggettoApiClient,
        },
        ScritturaElisioneRigaApiClient,
        {
          provide: 'scritturaElisioneRigaApiClient',
          useExisting: ScritturaElisioneRigaApiClient,
        },
        ScritturaPreconsolidamentoRigaApiClient,
        {
          provide: 'scritturaPreconsolidamentoRigaApiClient',
          useExisting: ScritturaPreconsolidamentoRigaApiClient,
        },
        ScritturaElisioneApiClient,
        {
          provide: 'scritturaElisioneApiClient',
          useExisting: ScritturaElisioneApiClient,
        },
        ScritturaPreconsolidamentoApiClient,
        {
          provide: 'scritturaPreconsolidamentoApiClient',
          useExisting: ScritturaPreconsolidamentoApiClient,
        },
        PerimetroApiClient,
        {
          provide: 'perimetroApiClient',
          useExisting: PerimetroApiClient,
        },
        GapApiClient,
        {
          provide: 'gapApiClient',
          useExisting: GapApiClient,
        },
        AnalisiBilancioApiClient,
        {
          provide: 'analisiBilancioApiClient',
          useExisting: AnalisiBilancioApiClient,
        },
        BilancioRigheApiClient,
        {
          provide: 'bilancioRigheApiClient',
          useExisting: BilancioRigheApiClient,
        },
        BilancioEnteApiClient,
        {
          provide: 'bilancioEnteApiClient',
          useExisting: BilancioEnteApiClient,
        },
        NotificaApiClient,
        {
          provide: 'notificaApiClient',
          useExisting: NotificaApiClient,
        },
        PartecipataIndirettaApiClient,
        {
          provide: 'partecipataIndirettaApiClient',
          useExisting: PartecipataIndirettaApiClient,
        },
        BilancioPartecipataApiClient,
        {
          provide: 'bilancioPartecipataApiClient',
          useExisting: BilancioPartecipataApiClient,
        },
        CompagineSocialeApiClient,
        {
          provide: 'compagineSocialeApiClient',
          useExisting: CompagineSocialeApiClient,
        },
        IncaricoPartecipataApiClient,
        {
          provide: 'incaricoPartecipataApiClient',
          useExisting: IncaricoPartecipataApiClient,
        },
        DocumentoPartecipataApiClient,
        {
          provide: 'documentoPartecipataApiClient',
          useExisting: DocumentoPartecipataApiClient,
        },
        ModelloContabileRigaApiClient,
        {
          provide: 'modelloContabileRigaApiClient',
          useExisting: ModelloContabileRigaApiClient,
        },
        PartecipataServizioApiClient,
        {
          provide: 'partecipataServizioApiClient',
          useExisting: PartecipataServizioApiClient,
        },
        AttivitaPartecipataApiClient,
        {
          provide: 'attivitaApiClient',
          useExisting: AttivitaPartecipataApiClient,
        },
        {
          provide: ApiClientConfig,
          useValue: config,
        },
        FileApiClient,
        // UserApiClient,
        // {
        //   provide: 'userApiClient',
        //   useExisting: UserApiClient,
        // },
        // RoleApiClient,
        // {
        //   provide: 'roleApiClient',
        //   useExisting: RoleApiClient,
        // },
        EnteApiClient,
        {
          provide: 'enteApiClient',
          useExisting: EnteApiClient,
        },
        UtenteApiClient,
        {
          provide: 'utenteApiClient',
          useExisting: UtenteApiClient,
        },
        RuoloApiClient,
        {
          provide: 'ruoloApiClient',
          useExisting: RuoloApiClient,
        },
        UtenteEnteApiClient,
        {
          provide: 'utenteEnteApiClient',
          useExisting: UtenteEnteApiClient,
        },
        ModuloApiClient,
        {
          provide: 'moduloApiClient',
          useExisting: ModuloApiClient,
        },
        ModuloEnteApiClient,
        {
          provide: 'moduloEnteApiClient',
          useExisting: ModuloEnteApiClient,
        },
        TipologiaRegistrazioneApiClient,
        {
          provide: 'tipologiaRegistrazioneApiClient',
          useExisting: TipologiaRegistrazioneApiClient,
        },
        MissioneApiClient,
        {
          provide: 'missioneApiClient',
          useExisting: MissioneApiClient,
        },
        ProgrammaApiClient,
        {
          provide: 'programmaApiClient',
          useExisting: ProgrammaApiClient,
        },
        PianoFinanziarioApiClient,
        {
          provide: 'pianoFinanziarioApiClient',
          useExisting: PianoFinanziarioApiClient,
        },
        PianoContiApiClient,
        {
          provide: 'pianoContiApiClient',
          useExisting: PianoContiApiClient,
        },
        ProspettoApiClient,
        {
          provide: 'prospettoApiClient',
          useExisting: ProspettoApiClient,
        },
        StrutturaProspettoApiClient,
        {
          provide: 'strutturaProspettoApiClient',
          useExisting: StrutturaProspettoApiClient,
        },
        MatriceApiClient,
        {
          provide: 'matriceApiClient',
          useExisting: MatriceApiClient,
        },
        RaccordoApiClient,
        {
          provide: 'raccordoApiClient',
          useExisting: RaccordoApiClient,
        },
        SaldoInizialeApiClient,
        {
          provide: 'saldoInizialeApiClient',
          useExisting: SaldoInizialeApiClient,
        },
        PartecipataApiClient,
        {
          provide: 'partecipataApiClient',
          useExisting: PartecipataApiClient,
        },
        UtentePartecipataApiClient,
        {
          provide: 'utentePartecipataApiClient',
          useExisting: UtentePartecipataApiClient,
        },
        TipologiaIncaricoApiClient,
        {
          provide: 'tipologiaIncaricoApiClient',
          useExisting: TipologiaIncaricoApiClient,
        },
        TipologiaPartecipazioneApiClient,
        {
          provide: 'tipologiaPartecipazioneApiClient',
          useExisting: TipologiaPartecipazioneApiClient,
        },
        TipologiaDocumentoApiClient,
        {
          provide: 'tipologiaDocumentoApiClient',
          useExisting: TipologiaDocumentoApiClient,
        },
        ServizioPubblicoApiClient,
        {
          provide: 'servizioPubblicoApiClient',
          useExisting: ServizioPubblicoApiClient,
        },
        MoltiplicatoreApiClient,
        {
          provide: 'moltiplicatoreApiClient',
          useExisting: MoltiplicatoreApiClient,
        },
        TipologiaCompensoApiClient,
        {
          provide: 'tipologiaCompensoApiClient',
          useExisting: TipologiaCompensoApiClient,
        },
        ParametroGapApiClient,
        {
          provide: 'parametroGapApiClient',
          useExisting: ParametroGapApiClient,
        },
        ParametroPerimetroApiClient,
        {
          provide: 'parametroPerimetroApiClient',
          useExisting: ParametroPerimetroApiClient,
        },
        ModelloContabileApiClient,
        {
          provide: 'modelloContabileApiClient',
          useExisting: ModelloContabileApiClient,
        },
        PartecipataEnteApiClient,
        {
          provide: 'partecipataEnteApiClient',
          useExisting: PartecipataEnteApiClient,
        },
        ControlloCostiPerMissioneApiClient,
        {
          provide: 'controlloCostiPerMissioneApiClient',
          useExisting: ControlloCostiPerMissioneApiClient,
        },
        ControlloSaldiApiClient,
        {
          provide: 'controlloSaldiApiClient',
          useExisting: ControlloSaldiApiClient,
        },
        ValoriAnnoPrecedenteApiClient,
        {
          provide: 'valoriAnnoPrecedenteApiClient',
          useExisting: ValoriAnnoPrecedenteApiClient,
        },
      ],
    };
  }
}
